<template>
  <div v-if="shop.bisno1">
    <v-container pa-0 fluid>
      <div class="insert-title">신청 내역 조회</div>
      <div class="insert-subtitle">
        입점 신청된 내역입니다.
        <div class="mobile-space"></div>
        수정을 원할 시, 고객센터로 연락주세요!
      </div>
      <div class="insert-border"></div>
      <div class="insert-content-all">
        <div class="insert-content insert-content-after">
          <div class="insert-content-left">
            사업자등록번호<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="000"
              outlined
              hide-details
              maxLength="3"
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.bisno1"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="00"
              outlined
              hide-details
              maxLength="2"
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.bisno2"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="00000"
              outlined
              hide-details
              maxLength="5"
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.bisno3"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            매장 명<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-store-name-input">
            <v-text-field
              placeholder="매장명"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              maxlength="30"
              counter="30"
              v-model="shop.shop_name"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            사업주 명<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-store-name-input">
            <v-text-field
              placeholder="사업주명"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.shop_ceo"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            사업주 휴대전화번호<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="010"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.ceo_phone1"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="1234"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.ceo_phone2"
            ></v-text-field>
          </div>
          <div class="insert-content-hyphen">-</div>
          <div class="insert-content-num-input">
            <v-text-field
              placeholder="5678"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.ceo_phone3"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            매장 주소<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-store-addr-input">
            <v-text-field
              placeholder="매장 주소를 검색해 주세요"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.shop_address"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-spec">
          <div class="insert-content-left insert-content-left-space"></div>
          <div
            class="insert-content-store-addr-input insert-content-store-addr-input-2"
          >
            <v-text-field
              placeholder="상세주소 입력"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.shop_address_detail"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            업종 카테고리<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input insert-content-select-list">
            <v-select
              outlined
              label="선택"
              :items="category"
              item-value="code"
              :value="shop.shop_item"
              item-text="name"
              background-color="#f2f2f2"
              readonly
              color="#01c9ff"
            ></v-select>
          </div>
          <div class="insert-content-space"></div>
          <div
            class="insert-content-num-input insert-content-select-list insert-content-select-list-2"
          >
            <v-select
              outlined
              label="선택"
              item-text="name"
              :value="shop.shop_item_2"
              item-value="code"
              :items="category"
              background-color="#f2f2f2"
              readonly
              color="#01c9ff"
            ></v-select>
          </div>
          <div class="insert-content-space"></div>
          <div
            class="insert-content-num-input insert-content-select-list insert-content-select-list-2"
          >
            <v-select
              outlined
              item-text="name"
              item-value="code"
              :value="shop.shop_item_3"
              label="선택"
              :items="category"
              background-color="#f2f2f2"
              readonly
              color="#01c9ff"
            ></v-select>
          </div>
        </div>
        <div class="insert-content insert-content-spec insert-content-warn">
          <div class="insert-content-left insert-content-left-space"></div>
          <div>※ 업종 카테고리는 최대 3개까지 선택 가능합니다.</div>
        </div>
        <!--첨부파일-->
        <!--        <div class="insert-content insert-content-other">
          <div class="insert-content-left">
            첨부파일<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-num-input insert-content-select-list insert-content-img-list">
            <img :src="shop.shop_file_no1" @error="replaceByDefault()"/>
            <p>사업자등록증</p>
          </div>
          <div class="insert-content-space"></div>
          <div
              class="
              insert-content-num-input
              insert-content-select-list
              insert-content-select-list-2
              insert-content-img-list
            "
          >
            <img :src="shop.shop_file_no2" @error="replaceByDefault">
            <p>영업신고증</p>
          </div>
          <div class="insert-content-space"></div>
          <div
              class="
              insert-content-num-input
              insert-content-select-list
              insert-content-select-list-2
              insert-content-img-list
            "
          >
            <img :src="shop.shop_file_no3" @error="replaceByDefault">
            <p>통장사본</p>
          </div>
        </div>-->
        <!--        <div class="insert-content insert-content-other clearfix">
          <div class="insert-content-left">
            업로드<span style="color: #01caff">*</span>
          </div>
          <div class="insert-content-store-addr-input insert-content-store-addr-input-2">
          <v-text-field
              label="사업자등록증"
              outlined
              hide-details
              readonly
              background-color="#f2f2f2"
              color="#01c9ff"
              v-model="shop.shop_file_no1"
          ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-spec">
          <div class="insert-content-left insert-content-left-space"></div>
          <div
              class="
              insert-content-store-addr-input insert-content-store-addr-input-2
            "
          >
            <v-text-field
                label="영업신고증"
                outlined
                hide-details
                readonly
                background-color="#f2f2f2"
                color="#01c9ff"
                v-model="shop.shop_file_no2"
            ></v-text-field>
          </div>
        </div>
        <div class="insert-content insert-content-spec">
          <div class="insert-content-left insert-content-left-space"></div>
          <div
              class="
              insert-content-store-addr-input insert-content-store-addr-input-2
            "
          >
            <v-text-field
                label="통장사본"
                outlined
                hide-details
                readonly
                background-color="#f2f2f2"
                color="#01c9ff"
                v-model="shop.shop_file_no3"
            ></v-text-field>
          </div>
        </div>-->
        <!--
        <div class="insert-content insert-content-other insert-content-select">
          <div class="insert-content-left insert-content-left-imp">
            배달 가능 여부<span style="color: #01caff">*</span>
          </div>
          <v-radio-group row hide-details class="insert-radio-group">
            <div class="insert-content-num-input insert-radio-btn">
              <v-radio
                label="배달 / 포장가능"
                color="#01c9ff"
                value="red"
                readonly
              ></v-radio>
            </div>
            <div class="insert-content-num-input insert-radio-btn">
              <v-radio
                label="배달만 가능"
                color="#01c9ff"
                value="red2"
                readonly
              ></v-radio>
            </div>
          </v-radio-group>
        </div>
        <div class="insert-content insert-content-other insert-content-select">
          <div class="insert-content-left insert-content-left-use">
            배달 대행사 사용 유무<span style="color: #01caff">*</span>
          </div>
          <v-radio-group row hide-details class="insert-radio-group">
            <div
              class="insert-content-num-input insert-radio-btn insert-radio-btn-1"
            >
              <v-radio
                label="예"
                color="#01c9ff"
                value="red"
                readonly
              ></v-radio>
            </div>
            <div
              class="insert-content-num-input insert-radio-btn insert-radio-btn-1"
            >
              <v-radio
                label="아니오"
                color="#01c9ff"
                value="red2"
                readonly
              ></v-radio>
            </div>
          </v-radio-group>
        </div>
        <div
          class="insert-content insert-content-other insert-content-order-checkbox"
        >
          <div class="insert-content-left insert-content-left-space"></div>
          <v-radio-group row hide-details class="insert-radio-group">
            <div
              class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
            >
              <v-radio
                label="생각대로"
                color="#01c9ff"
                value="red"
                readonly
              ></v-radio>
            </div>
            <div
              class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
            >
              <v-radio
                label="부릉"
                color="#01c9ff"
                value="red2"
                readonly
              ></v-radio>
            </div>
            <div
              class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
            >
              <v-radio
                label="바로고"
                color="#01c9ff"
                value="red3"
                readonly
              ></v-radio>
            </div>
            <div
              class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
            >
              <v-radio
                label="공유다"
                color="#01c9ff"
                value="red4"
                readonly
              ></v-radio>
            </div>
            <div
              class="insert-content-checkbox-block insert-radio-btn insert-radio-btn-2"
            >
              <v-radio
                label="기타"
                color="#01c9ff"
                value="red5"
                readonly
              ></v-radio>
            </div>
            <div class="insert-content-rider-name-input">
              <v-text-field
                placeholder="배달대행사 명"
                outlined
                hide-details
                readonly
                background-color="#f2f2f2"
              ></v-text-field>
            </div>
          </v-radio-group>
        </div> -->
      </div>
      <div class="complete-center-block">
        <div class="complete-center-img">
          <img src="@/assets/imgs/headset.png" class="headset" />
        </div>
        <div class="complete-center-right">
          <div class="complete-center-txt-1">
            고객센터
            <span class="complete-center-txt-1-2"> 1661-3773 </span>
          </div>
          <div class="complete-center-txt-2">
            문의사항은 고객센터로 연락주세요.
            <div class="tablet-space"></div>
            <div class="mobile-space"></div>
            (월~금, 오전 9시 ~ 오후 6시)
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import Shop from "@/api/Shop";

export default {
  data({ $route }) {
    return {
      ...$route.query,
      dialog: false,
      shop: {},
      category: [
        {
          code: "",
          name: "선택없음",
        },
        {
          code: "1001",
          name: "치킨/찜닭",
        },
        {
          code: "1004",
          name: "중식",
        },
        {
          code: "1005",
          name: "분식",
        },
        {
          code: "1008",
          name: "한식",
        },
        {
          code: "1003",
          name: "피자",
        },
        {
          code: "1006",
          name: "족발/보쌈",
        },
        {
          code: "1024",
          name: "패스트푸드",
        },
        {
          code: "1013",
          name: "돈까스/일식",
        },
        {
          code: "1025",
          name: "도시락/죽",
        },
        {
          code: "1026",
          name: "카페/디저트",
        },
        {
          code: "1014",
          name: "아시안/양식",
        },
        {
          code: "1007",
          name: "야식",
        },
      ],
    };
  },
  methods: {
    async getInfo(data) {
      const { data: res } = await Shop.getList(data);
      if (res.statusCode === 200) {
        return res.body.ret;
      } else {
        alert(res.body.ret);
        this.$router.replace({ name: "User_Check" });
      }
    },
    replaceByDefault(e) {
      e.target.src = require("@/assets/imgs/img_empty@2x.png");
    },
  },
  async mounted() {
    const infoData = {
      reg_no: this.shop_reg_no,
      phone: this.ceo_phone,
    };
    this.shop = await this.getInfo(infoData);
    console.log(this.shop);
    if (this.shop) {
      this.shop.bisno1 = this.shop.shop_reg_no.substring(0, 3);
      this.shop.bisno2 = this.shop.shop_reg_no.substring(3, 5);
      this.shop.bisno3 = this.shop.shop_reg_no.substring(5, 10);
      this.shop.ceo_phone1 = this.shop.ceo_tel.substring(0, 3);
      this.shop.ceo_phone2 = this.shop.ceo_tel.substring(3, 7);
      this.shop.ceo_phone3 = this.shop.ceo_tel.substring(7, 11);
    }
  },
};
</script>

<style scoped>
body {
  /* border: red solid 2px; */
  font-family: "PretendardRegular";
}

.container {
  font-family: "PretendardRegular";
}

.v-text-field,
.v-btn,
.v-select {
  border-radius: 0 !important;
}
.v-input--selection-controls {
  padding-top: 0;
}
.dialog-title {
  background-color: #01c9ff;
  color: #ffffff;
}

.insert-btn,
.insert-addr-btn,
.insert-code-btn,
.insert-check-btn {
  cursor: pointer;
}
.insert-content-img-list {
  position: relative;
  height: auto !important;
  padding: 0 0 50px;
  text-align: center;
}
.insert-content-img-list img {
  width: 100%;
  height: 400px;
}
.insert-content-img-list p {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  text-align: center;
}

/*
##Device = Desktops
##Screen = 1281px to higher resolution desktops
##Device = 데스크탑
##Screen = 1281px 이상 해상도 데스크탑
*/

@media (min-width: 1281px) {
  .container {
    width: 1170px !important;
  }
  .insert-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: left;
    color: #333333;
    margin-top: 50px;
    margin-bottom: 8px;
  }
  .insert-subtitle {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-bottom: 50px;
  }
  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 50px;
    width: 100%;
  }

  .insert-content-left {
    width: 184px;
    height: 29px;
    margin: 15px 30px 26px 0;
    font-family: "PretendardRegular";
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 240px;
    height: 60px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-content-store-name-input,
  .insert-btn,
  .insert-content-code-input,
  .insert-content-store-addr-input,
  .insert-content-space,
  .insert-content-checkbox-block,
  .insert-content-rider-name-input,
  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 7px 16px;
  }

  .insert-content-store-name-input {
    width: 500px;
    height: 60px;
  }

  .insert-content-store-addr-input {
    width: 760px;
    height: 60px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 160px;
    height: 56px;
    margin: 0 0 0 20px;
    padding: 14px 63px 17px;
    background-color: #333333;
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .insert-check-btn {
    padding: 14px 28px;
  }

  .insert-addr-btn {
    padding: 14px 44px;
  }
  .insert-content-space {
    margin: 17px 10px 16px;
  }

  .insert-content-warn {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: left;
    color: #01caff;
    margin-bottom: -30px;
  }

  .insert-btn-block {
    margin-top: 80px;
  }
  .real-insert-btn {
    float: right;
    width: 288px;
    height: 60px;
    margin: 26px 10px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }

  .insert-content-checkbox-block {
    margin-right: 32px;
  }

  .insert-content-rider-name-input {
    width: 155px;
    margin-top: -16px;
  }

  .insert-content-order-checkbox {
    margin-top: 0;
  }

  .insert-radio-group {
    padding-top: 16px;
  }
  .complete-center-block {
    width: 100%;
    height: 186px;
    margin: 50px 0 60px;
    padding: 24px 24px 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: 33px;
    margin-left: 39px;
  }

  .complete-center-txt-1 {
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-family: "PretendardRegular";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-top: 9px;
  }
  .headset {
    width: 138px;
  }
  .mobile-space,
  .mal_small,
  .tablet-space {
    display: none;
  }
}

/*
##Device = Laptops, Desktops
##Screen = B/w 1025px to 1280px
##Device = 랩탑, 데스크탑
##Screen = 1025px에서 1280px 사이
*/

@media (min-width: 768px) and (max-width: 1280px) {
  .container {
    width: 586px !important;
  }
  .insert-title {
    height: 59px;
    font-family: "PretendardRegular";
    font-size: 40px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.48;
    letter-spacing: -0.8px;
    text-align: center;
    color: #333333;
    margin-top: 50px;
    /* margin-bottom: 50px; */
  }
  .insert-subtitle {
    text-align: center;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: center;
    color: #333333;
    margin-top: 8px;
    margin-bottom: 50px;
  }

  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 50px;
    width: 100%;
  }

  .insert-content-left-space {
    display: none;
  }

  .insert-content-left {
    width: 586px;
    height: 29px;
    margin: 15px 30px 26px 0;
    font-family: "PretendardRegular";
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: -0.4px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 130px;
    height: 60px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-content-store-name-input,
  .insert-btn,
  .insert-content-code-input,
  .insert-content-store-addr-input,
  .insert-content-space,
  .insert-content-checkbox-block,
  .insert-content-rider-name-input {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 7px 16px;
  }

  .insert-content-store-name-input {
    width: 586px;
    height: 60px;
  }

  .insert-content-store-addr-input {
    width: 430px;
    height: 60px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 136px;
    height: 56px;
    margin: 0 0 0 20px;
    padding: 14px 51px 17px;
    background-color: #333333;
    font-family: "PretendardRegular";
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
  }

  .insert-check-btn {
    padding: 14px 16px;
  }

  .insert-addr-btn {
    padding: 14px 32px;
  }
  .insert-content-space {
    margin: 17px 5px 16px;
  }

  .insert-content-warn {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: left;
    color: #01caff;
    margin-bottom: -30px;
  }

  .insert-btn-block {
    margin-top: 30px;
  }
  .real-insert-btn {
    float: right;
    width: 288px;
    height: 60px;
    margin: 26px 2px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }

  .insert-content-rider-name-input {
    width: 155px;
    margin-top: -16px;
    margin-left: -61px;
  }

  .insert-content-order-checkbox {
    margin-top: 0;
  }

  .insert-radio-group {
    display: inline;
  }

  .insert-radio-btn {
    width: 150px;
  }
  .insert-radio-btn-2 {
    margin-bottom: 42px;
  }
  .insert-content-code-input,
  .insert-content-store-addr-input-2,
  .insert-code-btn {
    margin-top: 6px;
  }
  .insert-content-select-list {
    width: 188px;
  }
  .insert-content-left-use {
    margin-top: -29px;
  }
  .insert-content-left-imp {
    margin-top: 35px;
  }
  .complete-center-block {
    width: 100%;
    height: 186px;
    margin: 50px 0 60px;
    padding: 24px 11px 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: 24px;
    margin-left: 11px;
  }

  .complete-center-txt-1 {
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: -0.48px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-top: 9px;
  }

  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .headset {
    width: 138px;
  }
  .mobile-space,
  .mal_small {
    display: none;
  }
  .insert-content-img-list img {
    width: 100%;
    height: 300px;
  }
}

/*
##Device = Tablets, Ipads (portrait),
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(세로),
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) {
} */

/*
##Device = Tablets, Ipads (landscape)
##Screen = B/w 768px to 1024px
##Device = 태블릿, 아이패드(가로)
##Screen = 768px에서 1024px 사이
*/

/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
} */

/*
##Device = Low Resolution Tablets, Mobiles (Landscape)
##Screen = B/w 481px to 767px
##Device = 저해상도 태블릿, 모바일(가로)
##Screen = 481px에서 767px 사이
*/

@media (max-width: 767px) {
  .container {
    width: 324px !important;
  }
  .insert-title {
    font-family: "PretendardRegular";
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.48px;
    text-align: center;
    color: #333333;
    margin-top: 40px;
  }
  .insert-border {
    height: 1px;
    background-color: #333333;
  }

  .insert-subtitle {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: center;
    color: #333333;
    margin-top: 8px;
    margin-bottom: 40px;
  }

  .insert-content {
    width: 100%;
  }

  .insert-content-all {
    margin-top: 30px;
    width: 100%;
  }

  .insert-content-left-space {
    display: none;
  }

  .insert-content-left {
    width: 586px;
    height: 29px;
    margin: 0 30px 16px 0;
    font-family: "PretendardRegular";
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
  }

  .insert-content-num-input {
    width: 98px;
    height: 48px;
  }

  .insert-content::after {
    display: block;
    content: "";
    clear: both;
  }

  .insert-content-left,
  .insert-content-num-input,
  .insert-content-hyphen,
  .insert-content-store-name-input,
  .insert-btn,
  .insert-content-code-input,
  .insert-content-store-addr-input,
  .insert-content-space,
  .insert-content-checkbox-block,
  .insert-content-rider-name-input {
    float: left;
  }
  .insert-content-hyphen {
    margin: 17px 4px 16px;
  }

  .insert-content-store-name-input {
    width: 324px;
    height: 48px;
  }

  .insert-content-store-addr-input {
    width: 324px;
    height: 48px;
  }

  .insert-content-other {
    margin-top: 30px;
  }

  .insert-btn {
    width: 324px;
    height: 56px;
    margin-top: 9px;
    padding: 19px 51px 17px;
    background-color: #333333;
    font-family: "PretendardRegular";
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.07;
    letter-spacing: -0.28px;
    text-align: center;
    color: #ffffff;
  }

  .insert-addr-btn {
    padding: 18px 20px;
    width: 102px;
    margin: 1px 0 0 10px;
    height: 54px;
    /* padding: 19px 34px 17px; */
  }
  .insert-content-space {
    display: none;
  }

  .insert-content-warn {
    font-family: "PretendardRegular";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: -0.28px;
    text-align: left;
    color: #01caff;
    margin-bottom: -12px;
    margin-top: 15px;
  }

  .insert-btn-block {
    margin-top: 30px;
  }
  .real-insert-btn {
    float: right;
    width: 157px;
    height: 60px;
    margin: 26px 2px 60px;
    padding: 17px 16px;
    background-color: #01c9ff;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
  }

  .real-insert-btn-back {
    background-color: #e6e6e6;
    color: #333333;
  }

  .insert-content-rider-name-input {
    width: 155px;
    height: 48px;
    margin-top: -16px;
    margin-left: -61px;
  }

  .insert-content-order-checkbox {
    margin-top: 0;
  }

  .insert-radio-group {
    display: inline;
  }

  .insert-radio-btn {
    width: 150px;
  }
  .insert-radio-btn-2 {
    margin-bottom: 30px;
  }
  .insert-content-code-input {
    margin-top: 10px;
    width: 211px;
  }
  .insert-code-btn {
    width: 102px;
    margin: 11px 0 0 11px;
    height: 55px;
    padding: 19px 34px 17px;
  }
  .insert-content-store-addr-input-2 {
    width: 324px;
    margin-top: 10px;
  }
  .insert-radio-btn-1 {
    margin-bottom: 7px;
  }
  .insert-content-left-use {
    margin-top: -28px;
  }
  .insert-content-left-imp {
    margin-top: 8px;
  }
  .insert-content-select-list {
    width: 324px;
  }
  .insert-content-select-list-2 {
    margin-top: 13px;
  }
  .complete-center-block {
    width: 100%;
    height: 120px;
    margin: 50px 0 60px;
    padding: 16px 0 40px;
    border: solid 1px #e6e6e6;
    background-color: #f2f2f2;
  }

  .complete-center-right {
    margin-top: -1px;
    margin-left: 3px;
  }

  .complete-center-txt-1 {
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
    color: #333333;
  }

  .complete-center-txt-1-2 {
    font-family: "RobotoRegular";
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.36px;
    text-align: left;
    color: #ff3333;
  }

  .complete-center-txt-2 {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.32px;
    text-align: left;
    color: #333333;
    margin-top: 9px;
  }

  .complete-center-img,
  .complete-center-right {
    float: left;
  }
  .headset {
    width: 84px;
  }
}

/*
##Device = Most of the Smartphones Mobiles (Portrait)
##Screen = B/w 320px to 479px
##Device = 대부분의 스마트폰 모바일 기기(세로)
##Screen = 320px에서 479px 사이
*/

/* @media (min-width: 320px) and (max-width: 480px) {
} */
</style>
